import ProfileInteractionsStore from 'apps/profile/stores/profile-interactions-store';
import DNAStore from 'base/dna/dna-store';
import InteractionStore from 'apps/interactions/stores/interaction-store';
import FeatureStore from 'apps/layout/stores/feature-store';
import CustomFieldsStore from 'apps/interactions/stores/custom-fields-store';
import { useFluxStore } from '@evertrue/et-flux';

// This is all the data from various flux stores that we need, in some form or another, within the Interaction Form

// Possible Interaction Types to choose from for the Org.
// These can be created in data.evertrue by admins
const profileInteractionStoreMapState = (hasDxo) => ({
  interactionTypes: [
    ...new Set(
      (ProfileInteractionsStore.getWritableTypes(hasDxo) || []).map((type) => ({
        label: type.label,
        value: type.category,
      }))
    ),
  ],
});

// Information about the Labels for the Interaction Form
const interactionStoreMapState = () => ({
  labels: InteractionStore.getLabels(),
  labelOptions: InteractionStore.getLabelValues(),
  hasFetchedLabels: InteractionStore.hasFetchedLabels(),
});

// Various permissions for users and orgs.
// Eventually, we'd like to move all of this to LaunchDarkly
const featureStoreMapState = () => ({
  hasInteractionWrites: FeatureStore.hasInteractionWrites(),
  hasRmAssignments: FeatureStore.hasFeature('rm_assignments'),
  hasCustomFields: FeatureStore.hasFeature('interaction_custom_fields'),
});

// Custom Fields for the Org.
// These are configured in data.evertrue
const CustomFieldsStoreMapState = () => ({
  orgCustomFields: CustomFieldsStore.getCustomFields().filter((field) => field.active),
});

// Various Interaction-specific configurations set by the org in DNA.
// These can be modified by admin in console.evertrue
// Eventually, we'd like to migrate all of this into the new FieldTrigger Rules framework used for Conditional Fields
const DNAStoreMapState = () => ({
  isSummaryRequired: DNAStore.getByKey('required_summary'),
  interactionSolicitorLimit: DNAStore.getByKey('interaction_solicitor_limit'),
  interactionStandardFieldsConfig: DNAStore.getByKeyWithDefault({
    key: 'interaction_standard_fields_config',
    options: {
      max_length: (a, b) => a < b,
    },
  }),
  secondaryTargetLimit: DNAStore.getByKey('note-export-fixed-number-of-secondary-targets'),
});

// HOOK
const useInteractionFormFluxStore = (hasDxo) => {
  const { orgCustomFields = [] } = useFluxStore(CustomFieldsStore, CustomFieldsStoreMapState);
  const { interactionTypes = [] } = useFluxStore(ProfileInteractionsStore, () => profileInteractionStoreMapState(hasDxo));
  const labelState = useFluxStore(InteractionStore, interactionStoreMapState);
  const featurePermissions = useFluxStore(FeatureStore, featureStoreMapState);
  const dnaConfigs = useFluxStore(DNAStore, DNAStoreMapState);

  return {
    orgCustomFields,
    interactionTypes,
    ...labelState,
    ...featurePermissions,
    ...dnaConfigs,
  };
};

export default useInteractionFormFluxStore;
